import React from 'react';

import { Flash } from '@primer/components'

export default function(props) {
  return (
    <Flash
      variant="danger"
      marginBottom={'30px'}
    >
      GitHub replied permission denied. Do you have permission for this repo? Contact us if you think this is an error.
    </Flash>
  )
}
